import * as React from 'react';
import renderHTML from 'react-render-html';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { fetchPostWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import { isEmpty } from 'src/helpers';

class Pages extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true
		};
	}

	componentDidMount() {
		if (this.props.match.params.post_id) {
			this.props.fetchPostWP({
				post_id: this.props.match.params.post_id
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.match.params.post_id != this.props.match.params.post_id) {
			this.setState({
				loading: true
			});
			nextProps.fetchPostWP({
				post_id: nextProps.match.params.post_id
			});
		} else {
			if (nextProps.postWP.loading == false) {
				this.setState({
					loading: false
				});
				document.title = nextProps.postWP.data.post_title;
			}
		}

	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.postWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	render() {

		const { postWP } = this.props;

		return (
			<div className="news listNews newsDetail">
				<div className="container">
					<div className="row">
						<div className="col-md-12 col-lg-12 columnLeft">
							<div className="post single">
								<h1 className="title font2">
									<span>{postWP.data.post_title}</span>
								</h1>
								<div className="content-wrapper">
									<div className="content content-responsive postContent">
										{renderHTML(`${postWP.data.post_content}`)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="loading-data"></div>
				{this.state.loading ?
					<div className="loadingPage active"><img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'postWP'
]), mapDispatchToProps({
	fetchPostWP
}))(translate('translations')(Pages));



// WEBPACK FOOTER //
// ./src/containers/Pages.tsx